<template>
  <page-wrap>
    <grid :config="gridConfig"></grid>
    <editor
      :config="{id: gridConfig.id, api: 'NonConformityAnalyzes/Get/'}"
      :disabled="isDisabledForm"
    />
  </page-wrap>
</template>

<script>
import gridConfig from './GridConfig.json'

export default {
  name: 'NonConformityAnalyzes',
  components: {
    'page-wrap': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/PageWrap'),
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'editor': () => import(/* webpackChunkName: 'NonConformityAnalyzes' */ './Editor')
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  },
  computed: {
    isDisabledForm () {
      return !this.permission(this.$store.getters.get('permissions'), 'isAllowToEditCompanies')
    }
  }
}
</script>
